import styled from 'styled-components'
import {
  BiomarkersContainer,
  Container,
  ModalMUI,
  ReadMore,
  Title,
} from '../../pages/recommendations/Recommendations'
import HealthStatus from '../healthStatus/HealthStatus'
import MeasuredBiomarkers from '../measuredBiomarkers/MeasuredBiomarkers'
import { Modal, Skeleton } from '@mui/material'
import AboutBiomarker from '../modals/AboutBiomarker'
import { useContext, useState } from 'react'
import Percentage from '../perecentage/Percentage'
import GlobalContext from '../GlobalContext'
import { getThemeId, getUrl } from '../getSubjectId'
import Description from '../description/description'
import _ from 'underscore'
import { getScaleValue } from '../personalizedHealthEvaluation/PersonalizedHealthEvaluation'
import { TextLinkify } from "../RecomendAndNextSteps/RecomendAndNextSteps";
import ContainerContent from './../ContainerContent';
import { useTranslation } from 'react-i18next'

const Background = styled.div`
  width: 100%;
`

const Body = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: fit-content;
`

const LeftSide = styled.div`
  width: 100%;
`
const RightSide = styled.div`
  float: right;
`

const Text = styled.p`
  color: var(--text-main, #1a1a1a);
  font-size: 16px;
  font-weight: 300;
  line-height: 26px;
  letter-spacing: 0.32px;

  /* display: flex;
  flex-wrap: wrap;
  flex-direction: row; */
`
interface Window {
  onclickreadmore: (e: any) => void; // You can replace 'any' with a more specific event type if known
}

//@ts-ignore
window.onclickreadmore = (e) => {
  let el = e.closest('.editWrap')
  el.className = 'edit editWrap'//('edit')
  console.log('hhxhxhxhxhx', el)
}
export const getDescription = (value: string) => {
  //   return `<span title='asdfasdf' class="hoverText">asdfasdf</span>`
  return `<div class='editWrap'>${(value || '')
      .replace('/(fj)(.+?)/gi', (...args) => {
        return '<span onclick="onclickreadmore(this)" className="readMore readMoreAuto"> Read More ... </span>'
      })
    }</div>`
}

const Inflamation = (props: any) => {  
  const { i18n } = useTranslation()
  let { themeId } = props
  const [isModalOpen, setIsOpenModal] = useState(false)

  const handleCloseModal = () => setIsOpenModal(false)
  const handleModalOpen = () => setIsOpenModal(true)
  const { info } = props
  let subjectId = getThemeId()
  let subject = info.subjects.filter((it: any) => it._id == subjectId)[0]
  // console.log('debug indicators', info.indicators);
  // console.log(info.indicators)  
  let indicators = info.indicators.filter((it: any) => {
    let subjectId = it.subjectIds[0]
    return subjectId == themeId
  })
  if (!subject) {
    // window.location.href = getUrl('summary')
    return <></>
  }
  // console.log('qqqqq indicators444444444444', subject, info)

  const getLocalizedText = (text: any): string => {
    if (!text) return '';
    
    if (typeof text === 'string') {
      return text;
    }
    
    if (typeof text === 'object') {
      const currentLanguage = i18n.language;
      return text[currentLanguage] || text.en || Object.values(text)[0] || '';
    }
    
    return '';
  };

  const getSubjectName = (subject: any) => {
    if (!subject?.name) return '#' + subject._id
    
    const localizedName = getLocalizedText(subject.name);
    return localizedName || '#' + subject._id;
  }

  const isScoreMissing =
    info?.total?.value === undefined || info?.total?.value === null

  return (
    <ContainerContent>
      <Background className={'paddFigma whiteprint'}>
        <div>
          <Body className='flex9' style={{ flexDirection: 'row-reverse' }}>
            <LeftSide data-animch>
              <RightSide data-animch='6' data-right-side>
                <Percentage woBorder={true} background={true} woTitle={true} {...subject} total={info?.total} />
              </RightSide>
              <Title>{getSubjectName(subject)}</Title>
              <HealthStatus
                status={subject.scaleValue || getScaleValue(info?.total)}
                isScoreMissing={isScoreMissing}
              />
              <div style={{ marginTop: '48px' }} className={'titleDesc2'}>
                <TextLinkify text={getLocalizedText(subject.description)}></TextLinkify>
              </div>
              {/*<Description text={subject.description}></Description>*/}
            </LeftSide>
          </Body>
          <BiomarkersContainer data-animch='3' className={'paddTs'}>
            {(indicators || []).map((it: any, index: number) => {
              return (
                <MeasuredBiomarkers
                  value={it._value}
                  indicator={it}
                  onClickResize={handleModalOpen}
                  key={index}
                />
              )
            })}
          </BiomarkersContainer>
        </div>
      </Background>
    </ContainerContent>
  )
}

export default Inflamation
